/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-07-31 15:16:47
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-09-09 16:18:14
 */
var $ = require('jQuery');
var Component = require('../../Component');
var template = require('../../../template/content-menu.html');
var utils = require('../../../global/utils');
var isEmpty = utils.isEmpty;

var ContentMenu = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            selection: '<div class="im-menu-selection" data-index=${index}>${text}</div>'
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
      self._element.click(function(e){
        var _target = $(e.target);
        var index;
        if(e.target.tagName == 'DIV'){
          if(_target.hasClass('im-menu-selection')){
            index = _target.data('index');
            if(!isEmpty(index) && self._data.selections && self._data.selections[index]){
              self.triggerEvent('click', {
                action: self._data.selections[index].action,
                message: self._data.message,
                e:self._data.e
              });
            }
          }
        }
      });
    })(this);
};
ContentMenu.prototype = Object.create(Component.prototype);
ContentMenu.prototype.render = function () {
    var selections = this._data.selections || [];
    var html = '';
    var self = this;
    selections.forEach(function(selection, index){
      if(selection)html += self._options.selection.replace('${text}', selection.text).replace('${index}', index);
    });
    this._element.html(html);
};
ContentMenu.prototype.show = function (text) {
    Component.prototype.show.call(this);
};
ContentMenu.prototype.hide = function () {
    Component.prototype.hide.call(this);
};

module.exports = ContentMenu;
